import { UnderlineCombinedProps } from './types';

const usePresenter = (props: UnderlineCombinedProps): UnderlineCombinedProps => {
  return props;
};

export default usePresenter;
